// Common
import { Route, Switch } from 'react-router-dom'
import { ReactElement } from 'react'

// Components
import Wrapper from 'shared-components/wrapper'
import NotFoundPage from './public/not-found-page'
import CustomBrowserRouter from './custom-browser-router'
import Quiz from '../components/quiz'
import Done from 'components/done'
import Create from 'components/create/create'

function AppRouter(): ReactElement {
	return (
		<Wrapper>
			<CustomBrowserRouter>
				<Switch>
					<Route exact path="/" component={Quiz} />
					<Route path="/done" component={Done} />
					<Route path="/create" component={Create}/>
					<Route component={NotFoundPage} />
				</Switch>
			</CustomBrowserRouter>
		</Wrapper>
	)
}

export default AppRouter
